import { formatTimeAgo } from '@/lib/format';

interface TimeAgoProps {
  date: string;
  className?: string;
}

export function TimeAgo({ date, className = '' }: TimeAgoProps) {
  return (
    <time
      dateTime={date}
      className={`text-muted font-body ${className}`}
      title={new Date(date).toLocaleString()}
    >
      {formatTimeAgo(date)}
    </time>
  );
}
